var _path, _path2, _path3, _circle, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 134,
    viewBox: "0 0 144 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.658 19.2471L99.2241 51.2926L126.015 72.828L92.0456 78.083L86.7906 112.052L65.2551 85.2615L33.2096 97.695L45.6431 65.6495L18.8527 44.1141L52.8216 38.8591L58.0766 4.89012L79.6121 31.6806L111.658 19.2471Z",
    stroke: "url(#paint0_linear_1413_7624)",
    strokeLinecap: "round",
    strokeDasharray: "5.88 5.88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.25 28.654L89.8168 60.6995L116.607 82.235L82.6383 87.49L77.3833 121.459L55.8479 94.6685L23.8024 107.102L36.2359 75.0565L9.44544 53.521L43.4144 48.266L48.6694 14.2971L70.2048 41.0875L102.25 28.654Z",
    fill: "url(#paint1_linear_1413_7624)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140.201 114.368L137.558 121.012L143.252 125.476L136.032 126.566L134.916 133.608L130.339 128.054L123.528 130.632L126.17 123.988L120.477 119.524L127.696 118.434L128.813 111.392L133.39 116.946L140.201 114.368Z",
    fill: "url(#paint2_linear_1413_7624)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 13,
    r: 8,
    fill: "url(#paint3_linear_1413_7624)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1413_7624",
    x1: 72.4336,
    y1: -19.9769,
    x2: 148.955,
    y2: 41.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#632DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8052FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1413_7624",
    x1: 63.0264,
    y1: -10.5699,
    x2: 139.548,
    y2: 50.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#632DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8052FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1413_7624",
    x1: 140.201,
    y1: 114.368,
    x2: 123.942,
    y2: 131.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FADE78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1413_7624",
    x1: 8,
    y1: 5,
    x2: 8,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FADE78"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.bc125146f1ee98726e3ff4b313b60d57.svg";
export { ForwardRef as ReactComponent };